module.exports = __webpack_public_path__ + "static/media/013.f6d779d2.jpg";